import React from "react";
import Modal from "react-modal";
import { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import ProductPriceRequestForm from "./ProductPriceRequestForm";
import ProductPriceRequestSubmitted from "./ProductPriceRequestSubmitted";

interface ProductPriceRequestModalProperties {
    readonly productDetailInfo: ProductDetailInfo;
}

export default function ProductPriceRequestModal({ productDetailInfo }: ProductPriceRequestModalProperties): React.JSX.Element {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [email, setEmail] = React.useState("");

    const showModal = (): void => {
        setModalIsOpen(true);
    };

    const closeModal = (): void => {
        setModalIsOpen(false);
    };

    return (
        <>
            <div onClick={showModal}>
                <div className="product-attributes-summary-item-icon"><i className="fa-solid fa-coins"></i></div>
                Nabídni částku
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="modal-dialog modal-transition"
                overlayClassName="react-modal-backdrop modal-transition shop-modal-change"
                closeTimeoutMS={150}
            >
                <div className="modal-content">
                    <div className="modal-header empty modal-header-image">
                        <button type="button" className="close" onClick={closeModal}>
                            <i className="fa-solid fa-times"></i>
                        </button>
                    </div>

                    {isSubmitted
                        ? <ProductPriceRequestSubmitted email={email} onClose={closeModal} />
                        : <ProductPriceRequestForm
                            productDetailInfo={productDetailInfo}
                            onSubmitted={(submittedEmail): void => {
                                setIsSubmitted(true);
                                setEmail(submittedEmail);
                            }} />}
                </div>
            </Modal>
        </>
    );
}
